import { createStoreService } from '@zelos/shared/lib/default-store.service';
import { atom, useAtomValue } from 'jotai';
import {
  useEffect,
  useRef,
} from 'react';
import {
  breakpointMedium,
  breakpointSmall,
} from '@/constants/breakpoints';

const breakpointAtom = atom<'lg' | 'md' | 'sm'>('lg');

const {
  get,
  set,
} = createStoreService(breakpointAtom);

const setBreakpoint = () => {
  const breakpoint = (
    matchMedia(`(max-width: ${breakpointSmall})`).matches && 'sm' ||
    matchMedia(`(max-width: ${breakpointMedium})`).matches && 'md' ||
    'lg'
  );
  get() !== breakpoint && set(breakpoint);
};

export const useBreakpoint = () => useAtomValue(breakpointAtom);

export const useResizeObserveBody = () => {
  const bodyOffsetWidth = useRef<number | null>(null);
  const resizeObserver = useRef<ResizeObserver | null>(null);
  const timeoutId = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (resizeObserver.current) return;

    setBreakpoint();

    const instance = resizeObserver.current = new ResizeObserver(([{ contentRect, target }]) => {
      if (timeoutId.current !== null) clearTimeout(
        timeoutId.current,
      );

      timeoutId.current = setTimeout(() => {
        timeoutId.current = null;

        if (target === document.body && bodyOffsetWidth.current !== contentRect.width) {
          setBreakpoint();
          bodyOffsetWidth.current = contentRect.width;
        }
      }, 100);
    });

    instance.observe(document.body);

    return () => {
      instance.disconnect();
      resizeObserver.current = null;
    };
  }, []);
};
